import React, { useContext } from "react";
import { Link } from "react-router-dom";
import styles from "./Navbar.module.scss";
import { Context } from "../Store";
import { motion } from "framer-motion";
const FooterLink = () => {
  let { dir, translate } = useContext(Context);
  let { privacyPolicy, trems } = translate.navbar;
  let { title } = translate.footer;

  return (
    <>
      <div id={styles.footerLink}>
        {dir === "rtl" ? (
          <motion.li
            whileHover={{
              x: -4,
              transition: {
                type: "spring",
                mass: 1,
                stiffness: 1601,
                damping: 60,
              },
            }}
          >
            <Link
              to="privacy-Policy"
              className={`${styles.link} ${styles.linkHover}`}
            >
              {privacyPolicy[1]}
            </Link>
          </motion.li>
        ) : (
          <motion.li
            whileHover={{
              x: 4,
              transition: {
                type: "spring",
                mass: 1,
                stiffness: 1601,
                damping: 60,
              },
            }}
          >
            <Link
              to="privacy-Policy"
              className={`${styles.link} ${styles.linkHover}`}
            >
              {privacyPolicy[0]}
            </Link>
          </motion.li>
        )}

        {dir === "rtl" ? (
          <motion.li
            whileHover={{
              x: -4,
              transition: {
                type: "spring",
                mass: 1,
                stiffness: 1601,
                damping: 60,
              },
            }}
          >
            <Link
              to="terms&conditions"
              className={`${styles.link} ${styles.linkHover}`}
            >
              {trems[1]}
            </Link>
          </motion.li>
        ) : (
          <motion.li
            whileHover={{
              x: 4,
              transition: {
                type: "spring",
                mass: 1,
                stiffness: 1601,
                damping: 60,
              },
            }}
          >
            <Link
              to="terms&conditions"
              className={`${styles.link} ${styles.linkHover}`}
            >
              {trems[0]}
            </Link>
          </motion.li>
        )}
        {dir === "rtl" ? (
          <motion.li
            whileHover={{
              x: -4,
              transition: {
                type: "spring",
                mass: 1,
                stiffness: 1601,
                damping: 60,
              },
            }}
          >
            <Link to="payment&refund-policy" className={`${styles.link}`}>
              سياسة الدفع والاسترداد
            </Link>
          </motion.li>
        ) : (
          <motion.li
            whileHover={{
              x: 4,
              transition: {
                type: "spring",
                mass: 1,
                stiffness: 1601,
                damping: 60,
              },
            }}
          >
            <Link to="payment&refund-policy" className={`${styles.link}`}>
              Payment and Refund Policy
            </Link>
          </motion.li>
        )}

        <div className={styles.copyRight}>
          <h2>{dir === "ltr" ? title[0] : title[1]}</h2>
        </div>
      </div>
    </>
  );
};

export default FooterLink;
